/* eslint-disable react/sort-comp */
/* eslint-disable prefer-destructuring */
import React, { Component } from 'react';
import AWS from 'aws-sdk';
/** ******************************************************************
*  Components import
* ***************** */
import moment from 'utils/moment';
import FormSubmitted from '../forms/components/FormSubmitted';
import Loading from '../../components/loading';

import { GetFileName, S3Uploads } from '../services';
import { isLocal, hostName } from '../../constants/apiEnv';
import { getS3Region } from '../../utils/helpers';

/** ******************************************************************
*  Assets import
* ************* */
import styles from '../sms/hazard_builder.module.scss';
import SingleForm from './components/WaitRequestForm';
import DefaultFields from './components/defaulf_fields.json';

const url = hostName.slice(6);

class WaitListCreate extends Component {
  firstTime = true;

  constructor(props) {
      super(props);
        this.create = this.create.bind(this);
        this.state = {
          requiredMap: {},
          answers: {},
          showFormErrors: false,
          apiStatus: undefined,
          info: { report_time: moment().format() },
          fieldErrors: {
            first_name: true,
            last_name: true,
            email: true,
            phone: true,
            location: true,
            size_preference: true
          },
          loadingStatus: true,
          successMessage: ''
        };
        this.handleAnswerChanged = this.handleAnswerChanged.bind(this);
        const { match: { params: { id } } } = props;
        localStorage.setItem('portalBackendId', id);
        this.publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${id}${url}/public`;
  }

  async componentDidMount() {
    const { match: { params: { airportCode } } } = this.props;
    const { info } = this.state;
    fetch(`${this.publicUrl}/wait_list/get_schema/${airportCode}`)
    .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw Error(response.statusText);
      })
    .then((data) => {
      const requestSchema = data;
      const airport_data = data.airport_data;
      this.getData(requestSchema?.wait_list?.form?.public_form_settings?.success_message_attachment);
      this.setState({
        loadingStatus: false,
        airport_data,
        requestSchema,
        info: {
          ...info
        }
      });
    }).catch(() => {
      const message = 'There was a problem while retrieving the form';
      this.setState({
        message,
        apiStatus: false,
        loadingStatus: false,
        info: DefaultFields.default_fields
      });
    });
    this.getConfig();
  }


  componentDidUpdate(prevProps) {
    const { requestSchema } = this.state;
    if (this.firstTime && requestSchema && requestSchema.wait_list && requestSchema.wait_list.id && prevProps?.requestSchema !== requestSchema) {
      this.hazardProcess(requestSchema.wait_list);
      this.firstTime = false;
    }
  }

  hazardProcess = (data) => {
    const { info } = this.state;
    if (data?.schema) {
      let conditionalFields = {};
      let { fieldErrors, requiredMap } = this.state;
      const fields = data?.schema?.fields.filter(field => (
        field?.internal !== true
      )) || [];
      fields.forEach((field) => {
        if (field.type !== 'dataSource'
            && field.type !== 'dataSourceMultiselect'
            && field.type !== 'dataSourceMultiLevel'
            && field.type !== 'page_break'
            && field.type !== 'header'
            && field.type !== 'attachments') {
          requiredMap = { ...requiredMap, [field.id]: field.required };
          if (!field.conditional) {
            fieldErrors = {
              ...fieldErrors,
              [field.id]: field.required
            };
          } else {
            conditionalFields[field?.conditional_field?.key] = field;
            fieldErrors = {
              ...fieldErrors,
              [field.id]: false
            };
          }
        }
      });
      this.setState({ requiredMap, fieldErrors, conditionalFields, info });
    }
  };


  handleFieldErrorChanged = (id, value) => {
    this.setState(prevState => ({
      fieldErrors: {
        ...prevState.fieldErrors,
        [id]: value
      }
    }));
  };

  handleFieldsAnswerChanged = (answer, fieldId) => {
    const { conditionalFields } = this.state;
    if (conditionalFields?.[fieldId] && conditionalFields?.[fieldId].required) {
      const conditionValues = conditionalFields[fieldId]?.conditional_values;
      let fieldValue = answer;
      let enabelCondition = false;
      if (typeof fieldValue === 'boolean') fieldValue = fieldValue.toString();
      if (typeof fieldValue === 'object' && fieldValue?.level_0) {
        enabelCondition = Object.values(fieldValue)?.filter(value => value !== '')?.join()
        === Object.values(conditionValues[0])?.filter(value => value !== '')?.join();
      } else {
      enabelCondition = conditionValues.some(value => fieldValue?.includes(value?.value));
      }
      this.handleFieldErrorChanged(conditionalFields[fieldId].id, enabelCondition);
      this.setState(prevState => ({
        answers: {
          ...prevState.answers,
          [fieldId]: answer,
          [conditionalFields[fieldId].id]: ''
        }
      }));
    } else {
      this.setState(prevState => ({
        'answers': {
          ...prevState.answers,
          [fieldId]: answer
        }
      }));
    }
  return null;
};

  handleAnswerChanged = (answer, fieldId) => {
    const { conditionalFields } = this.state;
    const DEFAULT_FIELD_MAP = {
      location: 'default_location',
      size_preference: 'default_preferences'
    };
    if (conditionalFields?.[DEFAULT_FIELD_MAP[fieldId]] && conditionalFields?.[DEFAULT_FIELD_MAP[fieldId]].required) {
      const conditionValues = conditionalFields[DEFAULT_FIELD_MAP[fieldId]]?.conditional_values;
      let fieldValue = answer;
      let enabelCondition = false;
      if (typeof fieldValue === 'boolean') fieldValue = fieldValue.toString();
      if (typeof fieldValue === 'object' && fieldValue?.level_0) {
        enabelCondition = Object.values(fieldValue)
            ?.filter(value => value !== '')
            ?.join() === Object.values(conditionValues[0])
            ?.filter(value => value !== '')
            ?.join();
      } else {
        enabelCondition = conditionValues.some(value => fieldValue?.includes(value?.value));
      }
      this.handleFieldErrorChanged(conditionalFields[DEFAULT_FIELD_MAP[fieldId]].id, enabelCondition);
      this.setState(prevState => ({
        info: {
          ...prevState.info,
          [fieldId]: answer
        },
        answers: {
          ...prevState.answers,
          [conditionalFields[DEFAULT_FIELD_MAP[fieldId]].id]: ''
        }
      }));
    } else {
      this.setState(prevState => ({
        info: {
          ...prevState.info,
          [fieldId]: answer
        }
      }));
    }
    return null;
  };

  getConfig = () => {
    AWS.config.update({
      region: process.env.REACT_APP_REGION
    });
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID
    });
    return AWS.config.credentials.getPromise();
  };

  getData = (fileName) => {
    const { match: { params: { id: code } } } = this.props;
    const s3 = new AWS.S3({
      apiVersion: '2006-03-01',
      region: getS3Region()
    });

    const params = {
      Bucket: `${process.env.REACT_APP_S3PREFIX}${isLocal? 'local' : code}-attachments/conditions/wait_list`,
      Key: `${fileName}`,
      ResponseCacheControl: 'no-cache'
    };

    new Promise((resolve, reject) => {
      s3.getObject(params, (err, data) => {
        if (err) {
          return reject(err);
        }
        return resolve(data);
      });
    }).then((response) => {
      const info = response.Body.toString();
      this.setState({ successMessage: info });
    }).catch(() => {
      this.setState({ successMessage: '' });
    });
  };

  handleUploadAttachments = async (attachments, entity, airportCode) => {
    const attachmentIds = [];
    const newAttachments = [];
    attachments.forEach((e) => {
      if (!e.id) {
        newAttachments.push(e);
      }
    });
    let fileIds = '';
    if (newAttachments?.length > 0) {
      fileIds = await this.getFileNames(newAttachments?.length, airportCode);
    }
    if (fileIds) {
      await this.doS3Upload(newAttachments, fileIds, entity || 'wait_list').then(() => {
        fileIds.filename.forEach((attachmentId) => {
          attachmentIds.push(String(attachmentId));
        });
      });
    }

    return attachmentIds;
  }

  create = async () => {
    const { answers, info, fieldErrors, requestSchema } = this.state;
    const { match: { params: { airportCode } } } = this.props;
    let noErrors = Object.keys(fieldErrors).every(
      k => fieldErrors[k] === false
      );
    if (noErrors) {
      this.setState({ loadingStatus: true });
      const size = requestSchema?.wait_list?.default_fields?.fields?.default_preferences?.values?.filter(loc => (
        info?.size_preference?.filter(pre => +loc.key === +pre)?.length > 0))?.map(s => s?.value)?.join(';');
      const data = {
        report_date: moment(info.wait_report_date).format('YYYY-MM-DD'),
        report_time: moment(info.report_time).format('HH:mm'),
        reported_date: `${moment(info.wait_report_date).format('YYYY-MM-DD')} ${moment(info.report_time).format('HH:mm:ssZ')}`,
        first_name: info?.first_name,
        last_name: info?.last_name,
        email: info?.email,
        phone: info?.phone,
        location: requestSchema?.wait_list?.default_fields?.fields?.default_location?.values?.find(loc => +loc.key === +info?.location)?.value,
        space_size: size.toString(),
        response: { ...answers }
      };
      const attachmentFields = requestSchema?.wait_list?.schema?.fields?.filter(schemaField => (
        schemaField?.type === 'attachments'));
      if (attachmentFields?.length > 0) {
        // eslint-disable-next-line no-restricted-syntax
        for (const { id: attachmentField, type } of attachmentFields) {
          if (type === 'attachments' && data.response[attachmentField]?.length > 0) {
            // eslint-disable-next-line no-await-in-loop
            data.response[attachmentField] = await this.handleUploadAttachments(data.response[attachmentField], 'wait_list', airportCode);
          }
        }
      }

      const newAttachments = [];
      if (info.attachments && info.attachments.length > 0) {
          info.attachments.forEach((e) => {
          if (!e.id) {
              newAttachments.push(e);
          }
        });
      }
      let fileIds = '';
      if (newAttachments.length > 0) {
        fileIds = await this.getFileNames(newAttachments.length, airportCode);
      }
      if (fileIds) {
        await this.doS3Upload(newAttachments, fileIds, 'wait_list').then(() => {
          fileIds.filename.forEach((attachmentId) => {
            data.attachments.push(attachmentId.toString());
          });
        });
        data.airportCode = this.props.match.params.airportCode;
      }
      if (
        'removedAttachments' in info
        && info?.removedAttachments?.length > 0
      ) {
        data.removedAttachments = info.removedAttachments;
      } else {
        try {
          await fetch(`${this.publicUrl}/wait_list/create_wait_list/${airportCode}`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: { 'Content-Type': 'application/json' }
          })
          .then(response => response.json())
          .then(() => {
            this.setState({
              message: 'Your report has been submitted successfully.A staff member from the Airport safety team will be reaching out to you soon.',
              apiStatus: true,
              loadingStatus: false
            });
          });
        } catch (error) {
          let message = 'There was a problem while submitting the form';
          if (error && error.detail) message = error.detail;
          this.setState({
            message,
            apiStatus: true,
            loadingStatus: false
          });
        }
      }
      } else {
        this.setState({ showFormErrors: true });
      }
  };

  getFileNames = async (count, airportCode) => {
    const response = await GetFileName.getPublicUploadFileName(count, airportCode);
    return response;
  };

  doS3Upload = async (files, fileIds, entity) => {
    const { match } = this.props;
    const installation = match.params.id;
    const airportCode = match.params.airportCode;
    const response = await S3Uploads.uploadFiles(
        files,
        fileIds.filename,
        entity,
        installation,
        airportCode
    );
    return response;
  };

render() {
  const {
    info,
    apiStatus,
    showFormErrors,
    requiredMap,
    answers,
    loadingStatus,
    requestSchema,
    airport_data,
    message,
    successMessage
  } = this.state;

  const dataSchema = requestSchema?.wait_list?.schema?.fields?.filter(field => (
    field.type!=='dataSource'
    && field.type!=='dataSourceMultiselect'
    && field?.internal !== true
  ));
  const customFields = dataSchema?.map(order => order.id) || [];
  let fieldsOrdering = DefaultFields.default_fields.map(order => order.id);
  if (customFields?.length > 0) fieldsOrdering = [...fieldsOrdering, ...customFields];
  if (requestSchema?.wait_list?.default_fields?.ordering?.length > 0) {
    fieldsOrdering = requestSchema.wait_list?.default_fields?.ordering;
  }
return (
  <>
  {!apiStatus
    && <div className={styles.Image}>
      {airport_data?.image ? <img src={airport_data?.image} alt="airport_logo" /> : ''}
       </div>
  }
    {loadingStatus && (
      <Loading loadingStatus={loadingStatus} />
    )}
    <div className={styles.container}>
      {!apiStatus && (
        <SingleForm
          handleAnswerChanged={this.handleAnswerChanged}
          info={info}
          handleFieldErrorChanged={this.handleFieldErrorChanged}
          showFormErrors={showFormErrors}
          requestSchema={requestSchema}
          airport_data={airport_data}
          requiredMap={requiredMap}
          answers={answers}
          create={this.create}
          fieldsOrdering={fieldsOrdering}
          dataSchema={dataSchema || []}
          defaultFieldSchema={requestSchema?.wait_list?.default_fields?.fields || {}}
          datasources={requestSchema?.wait_list?.global_data_source}
          handleFieldsAnswerChanged={this.handleFieldsAnswerChanged}
          isWaitListCreate
        />
      )}
    {apiStatus && (
      <div className={`${styles.container} ${styles.formSubmitContainer}`}>
        <FormSubmitted name=""
          message={message} logo={requestSchema?.airport_data?.image}
          successMessage={successMessage}
        />
      </div>
    )}
    </div>
  </>
);
}
}

export default WaitListCreate;
